export default "__VITE_ASSET__D$qDe1d3__"